
import CompareTable from '../contentTypes/compareTable/compareTable'
import Image from '../contentTypes/image/image'
import RegularVideo from '../contentTypes/video/regularVideo'
import WistiaVideo from '../contentTypes/video/wistiaVideo'
import Text from '../contentTypes/text/text'
import Header from '../contentTypes/header/header'
import ItemCarousel from '../contentTypes/itemCarousel/itemCarousel'
import CompareCarousel from '../contentTypes/compareCarousel/compareCarousel'
import Faq from '../contentTypes/faq/faq'
import Divider from '../contentTypes/divider/greyGradient'

export default function ListEnhancedContent(props) {

    let content = props.currentItemECData.map( current => {

      if (current.type === 'compareTable'){
        return <CompareTable tableData={current} {...props} key={current.richId} />
      } else if (current.type === 'image') {
        return <Image data={current} key={current.richId} />
      } else if (current.type === 'itemCarousel' || current.type === 'productModule'  ) {
        return <ItemCarousel data={current} key={current.richId} website={this.props.website}  />
      } else if (current.type === 'compareCarousel' ) {
        return <CompareCarousel data={current} key={current.richId} website={this.props.website} urlParameters={this.props.urlParameters}  />
      } else if (current.type === 'faq') {
        return <Faq data={current} key={current.richId} />
      } else if (current.type === 'divider') {
        return <Divider data={current} key={current.richId} />
      } else if (current.type === 'text') {
        return <Text data={current} key={current.richId} />
      } else if (current.type === 'video') {
        return <RegularVideo data={current} key={current.richId} fixedHeight={props.fixedHeight} />
      } else if (current.type === 'wistiaVideo') {
        return <WistiaVideo data={current} key={current.richId} fixedHeight={props.fixedHeight} />
      } else if (current.type === 'header') {
        return <Header data={current} key={current.richId} />
      }

    })

    //let customClassName = props.mobileHide === true || props.mobileHide === "true" ? 'hiddenWalmartMobile col-xs-12' : 'col-xs-12'

    //testing
    let customClassName = 'col-xs-12'

    return (
			<div className={'row ' + customClassName}  >
          {content}
			</div>
		);
	}



// WEBPACK FOOTER //
// ./components/util/listEnhancedContent.js